module.exports = __webpack_public_path__ + "img/road-sun.4da491a8.jpg";